module.exports = __webpack_public_path__ + "img/logo-16.ae0469ed.png";